import { isProductionEnvironment } from "config";
import PERMISSIONS from "rbac/Permissions.json";
import { ROUTES } from "rbac/RbacContentProvider";
import { hasRoleIn } from "rbac/RbacHelper";
import Admin from "views/Admin/Admin";
import ClientView from "views/Admin/ClientView/ClientView";
import CustomerList from "views/Admin/CustomerList/CustomerList";
import CustomerView from "views/Admin/CustomerView/CustomerView";
import UserList from "views/Admin/UserList/UserList";
import TestData from "views/Admin/TestData/TestData";
import AgentDashboard from "views/AgentWorkspace/AgentDashboard/AgentDashboard";
import CallGroupDetails from "views/AgentWorkspace/CallGroupDetails/CallGroupDetails";
import CallGroupFilterScreen from "views/AgentWorkspace/CallGroupFilterScreen/CallGroupFilterScreen";
import CallGroupList from "views/AgentWorkspace/CallGroupList/CallGroupList";
import TranscribeDetails from "views/AgentWorkspace/TranscribeDetails/TranscribeDetails";
import TranscriberProgramTypeList from "views/AgentWorkspace/TranscriberProgramTypeList/TranscriberProgramTypeList";
import TranscriberProgramList from "views/AgentWorkspace/TranscriberProgramList/TranscriberProgramList";
import DmrTranscribeDetails from "views/AgentWorkspace/DmrTranscribeDetails/DmrTranscribeDetails";
import AiAgentConfig from "views/AgentWorkspace/AiAgentConfig/AiAgentConfig";
import DashboardDetails from "views/Analytics/DashboardDetails/DashboardDetails";
import TableOfContents from "views/Analytics/TableOfContents/TableOfContents";
import BlacklistedContactsList from "views/BlacklistedContacts/BlacklistedContactsList/BlacklistedContactsList";
import AiCallLogList from "views/Admin/AiCallLog/AiCallLogList";
import ActiveRadar from "views/Cat/ActiveRadar/ActiveRadar";
import AllDrugs from "views/Cat/AllDrugs/AllDrugs";
import CodexVersion from "views/Cat/CodexVersion/CodexVersion";
import UpdatedDynamicSwitchGroupDetails from "views/Cat/CompareCodexVersion/UpdatedDSGDetails/UpdatedDynamicSwitchGroupDetails";
import UpdatedDynamicSwitchGroupList from "views/Cat/CompareCodexVersion/UpdatedDynamicSwitchGroupList";
import DynamicSwitchGroup from "views/Cat/DynamicSwitchGroup/DynamicSwitchGroup";
import DynamicSwitchGroupDetails from "views/Cat/DynamicSwitchGroupDetails/DynamicSwitchGroupDetails";
import DynamicSwitchGroupList from "views/Cat/DynamicSwitchGroupList/DynamicSwitchGroupList";
import UnprocessedFaxProgramTypeList from "views/Switch/UnprocessedFaxProgramTypeList/UnprocessedFaxProgramTypeList";

import NewDrug from "views/Cat/NewDrug/NewDrug";
import CycleList from "views/Cycle/CycleList/CycleList";
import MemberDetail from "views/MemberProfile/MemberDetail/MemberDetail";
import MemberList from "views/MemberProfile/MemberList/MemberList";
import DrugGroup from "views/Paw/DrugGroup/DrugGroup";
import DrugGroupDetails from "views/Paw/DrugGroupDetails/DrugGroupDetails";
import PawDsgList from "views/Paw/PawDsgs/PawDsgList";
import PawGroup from "views/Paw/PawGroup/PawGroup";
import PawLoad from "views/Paw/PawLoad/PawLoad";
import PrescribersProfileList from "views/PrescribersProfileList/PrescribersProfileList";
import BulkList from "views/Schedular/BulkList/BulkList";
import SchedularForm from "views/Schedular/SchedularForm";
import HscSwitchList from "views/Switch/HscSwitchList/HscSwitchList";
import SwitchDetails from "views/Switch/SwitchDetails/SwitchDetails";
import SwitchList from "views/Switch/SwitchList/SwitchList";
import UnprocessedFaxDetailsV2 from "views/Switch/UnprocessedFaxDetailsV2/UnprocessedFaxDetails";
import UnprocessedFaxListV2 from "views/Switch/UnprocessedFaxListV2/UnprocessedFaxList";
import ChangePassword from "views/User/ChangePassword";
import SwimSwitchList from "../views/AgentWorkspace/SwimSwitchList/SwimSwitchList";
import BatchList from "../views/Batch/BatchList/BatchList";
import Landing from "../views/Landing/Landing";
import RawList from "../views/Raw/RawList/RawList";
import RawProgramTypeList from "../views/Raw/RawProgramTypeList/RawProgramTypeList";
import FaxDisposition from "../views/Raw/FaxDisposition/FaxDisposition";
// not to be used from outside this file directly, use accessor methods below
const getDashboardRoutes = () => {
  const catBasePath = "/cat";
  const catRoutes = [
    {
      name: "Select Codex Version",
      path: `${catBasePath}`,
      component: CodexVersion,
    },
    {
      name: "DSG",
      path: `${catBasePath}/codex/dsg`,
      component: DynamicSwitchGroupList,
    },
    {
      name: "Compare Codex",
      path: `${catBasePath}/codex/updated-dsg`,
      component: UpdatedDynamicSwitchGroupList,
    },
    {
      name: "Internal Drug Search",
      path: `${catBasePath}/codex/all-drugs`,
      component: AllDrugs,
    },
    {
      name: "Active Radar Search",
      path: `${catBasePath}/codex/active-radar`,
      component: ActiveRadar,
      excludeFromNavigation: true,
    },
    {
      name: "New Drug",
      path: `${catBasePath}/dynamic-switch-groups/:dynamicSwitchGroupId/add-new-drug`,
      component: NewDrug,
      excludeFromNavigation: true,
    },
    {
      name: "Dynamic Switch Group Details",
      path: `${catBasePath}/dynamic-switch-groups/:dynamicSwitchGroup`,
      component: DynamicSwitchGroupDetails,
      excludeFromNavigation: true,
    },
    {
      name: "Compare Dynamic Switch Group Details",
      path: `${catBasePath}/codex-version/:codexVersion/dynamic-switch-groups/:dynamicSwitchGroup`,
      component: UpdatedDynamicSwitchGroupDetails,
      excludeFromNavigation: true,
    },
    {
      name: "Dynamic Switch Group",
      path: `${catBasePath}/codex/dsg/new`,
      component: DynamicSwitchGroup,
      excludeFromNavigation: true,
    },
  ];

  const paw2_0BasePath = "/paw";
  const paw2_0Routes = [
    {
      name: "PAW Load",
      path: `${paw2_0BasePath}/paw-load`,
      component: PawLoad,
      accessors: [
        PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
        PERMISSIONS.PERM_PAW_LOAD_MANAGE,
      ],
    },
    {
      name: "PAW Groups",
      path: `${paw2_0BasePath}/paw-groups`,
      component: PawGroup,
      accessors: [
        PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE,
        PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
      ],
    },
    {
      name: "Drug Groups",
      path: `${paw2_0BasePath}/paw-groups/:pawGroupId/drug-groups`,
      component: DrugGroup,
      excludeFromNavigation: true,
      accessors: [
        PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE,
        PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
      ],
    },
    {
      name: "PAW DSGs",
      path: `${paw2_0BasePath}/paw-dsgs/`,
      component: PawDsgList,
      accessors: [PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE],
    },
    {
      name: "Drug Group Details",
      path: `${paw2_0BasePath}/paw-groups/:pawGroupId/drug-groups/:drugGroup`,
      component: DrugGroupDetails,
      excludeFromNavigation: true,
      accessors: [
        PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE,
        PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
      ],
    },
  ];

  const profileBasePath = "/profiles";
  const profileRoutes = [
    {
      name: "Member List ",
      path: `${profileBasePath}/members/list`,
      component: MemberList,
      accessors: [PERMISSIONS.PERM_MEMBER_MANAGE],
    },
    {
      name: "Member Details",
      path: `${profileBasePath}/members/:memberId/details`,
      component: MemberDetail,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_MEMBER_MANAGE],
    },
    {
      name: "Prescriber List ",
      path: `${profileBasePath}/prescribers/list`,
      component: PrescribersProfileList,
      accessors: [PERMISSIONS.PERM_PRESCRIBER_PROFILE_MANAGE],
    },
  ];

  const rawBasePath = "/raw";
  const rawRoutes = [
    {
      name: "Response List ",
      path: `${rawBasePath}/program-type-list`,
      component: RawProgramTypeList,
    },
    {
      name: "Response List Detail",
      path: `${rawBasePath}/list`,
      component: RawList,
      excludeFromNavigation: true,
    },
    {
      name: "Response Details",
      path: `${rawBasePath}/:rawId`,
      component: FaxDisposition,
      excludeFromNavigation: true,
    },
    {
      name: "Switch Details for Response",
      path: `${rawBasePath}/:rawId/wf/:wfItemId`,
      component: SwitchDetails,
      excludeFromNavigation: true,
    },
  ];

  const switchBasePath = "/switch";
  const hscSwitchBasePath = "/hsc-switch";
  const unprocessedFaxBasePath = "/unprocessed-fax";
  const transcriptionBasePath = "/transcription";
  const switchRoutes = [
    {
      name: "Switch List",
      path: `${switchBasePath}/list`,
      component: SwitchList,
      accessors: [PERMISSIONS.PERM_SWIM_WORKFLOW_ACCESS],
    },
    {
      name: "HSC Switch List",
      path: `${hscSwitchBasePath}/list`,
      component: HscSwitchList,
      accessors: [PERMISSIONS.PERM_HSC_SWITCH_LIST_MANAGE],
    },
    {
      name: "Unprocessed Fax List",
      path: `${unprocessedFaxBasePath}/program-type-list`,
      component: UnprocessedFaxProgramTypeList,
      accessors: [PERMISSIONS.PERM_FAX_MANAGE],
    },
    {
      name: "Transcriber Fax Programs",
      path: `${transcriptionBasePath}/program-type-list`,
      component: TranscriberProgramTypeList,
      accessors: [PERMISSIONS.PERM_AW_TRANSCRIPTION_MANAGE],
    },
    {
      name: "Transcriber Fax lists",
      path: `${transcriptionBasePath}/list`,
      component: TranscriberProgramList,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_AW_TRANSCRIPTION_MANAGE],
    },
    {
      name: "DMR Transcribed Fax List",
      path: `${transcriptionBasePath}/dmr/list`,
      component: TranscriberProgramList,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_AW_TRANSCRIPTION_MANAGE],
    },
    {
      name: "DMR Transcription Details",
      path: `${transcriptionBasePath}/dmr/:programTranscriptionInfoUuid`,
      component: DmrTranscribeDetails,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_AW_TRANSCRIPTION_MANAGE],
      excludeFromNavigation: true,
    },
    {
      name: "Switch Details",
      path: `${switchBasePath}/:wfItemId`,
      component: SwitchDetails,
      excludeFromNavigation: true,
    },
    {
      name: "Switch Disposition",
      path: `${switchBasePath}/disposition/:rawId`,
      component: FaxDisposition,
      excludeFromNavigation: true,
    },
    {
      name: "Transcriber Fax Details",
      path: `${transcriptionBasePath}/:transcriptionId`,
      component: TranscribeDetails,
      excludeFromNavigation: true,
    },
    {
      name: "Unprocessed Fax Details",
      path: `${unprocessedFaxBasePath}/fax-details-v2/:faxType/:faxInfoId`,
      component: UnprocessedFaxDetailsV2,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_FAX_MANAGE],
    },
    {
      name: "Unprocessed Fax List",
      path: `${unprocessedFaxBasePath}/fax-list`,
      component: UnprocessedFaxListV2,
      excludeFromNavigation: true,
      accessors: [PERMISSIONS.PERM_FAX_MANAGE],
    },
  ];
  const schedulerBasePath = "/scheduler";
  const schedulerRoutes = [
    {
      name: "Scheduler",
      path: `${schedulerBasePath}`,
      component: SchedularForm,
    },
    {
      name: "Batch",
      path: `${schedulerBasePath}/batch/list`,
      component: BatchList,
    },
    {
      name: "Cycle",
      path: `${schedulerBasePath}/cycle/list`,
      component: CycleList,
    },
    {
      name: "Bulk Action",
      path: `${schedulerBasePath}/bulk-action/list`,
      component: BulkList,
    },
    {
      name: "Bulk Action Details",
      path: `${schedulerBasePath}/bulk-action/:bulkActionUuid`,
      component: SchedularForm,
      excludeFromNavigation: true,
    },
  ];
  const agentWorkspaceBasePath = "/agent-workspace";
  const agentWorkspaceRoutes = [
    {
      name: "Agent Dashboard",
      path: `${agentWorkspaceBasePath}/dashboard`,
      component: AgentDashboard,
      accessors: [PERMISSIONS.PERM_AW_MANAGE],
    },
    {
      name: "Call Group List",
      path: `${agentWorkspaceBasePath}/list`,
      component: CallGroupList,
      accessors: [PERMISSIONS.PERM_AW_MANAGE],
    },
    {
      name: "Call Groups",
      path: `${agentWorkspaceBasePath}/filters`,
      component: CallGroupFilterScreen,
      accessors: [PERMISSIONS.PERM_AW_MANAGE],
      // Visibility toggled in Sidebar via agent next-call-group flow gate (F7).
      excludeFromNavigation: true,
    },
    {
      name: "SWIM Switch List",
      path: `${agentWorkspaceBasePath}/swim-switch-list`,
      component: SwimSwitchList,
      accessors: [PERMISSIONS.PERM_AW_MANAGE],
    },
    {
      name: "AI Calls Configuration",
      path: `${agentWorkspaceBasePath}/ai-agent-config`,
      component: AiAgentConfig,
      accessors: [PERMISSIONS.PERM_AW_SCHEDULE_AI_CALL],
    },
    {
      name: "Call Group Detail",
      path: `${agentWorkspaceBasePath}/call-group-details/:callGroupId`,
      component: CallGroupDetails,
      excludeFromNavigation: true,
    },
  ];

  const adminBasePath = "/admin";
  const adminRoutes = [
    {
      name: "Platform",
      path: `${adminBasePath}/platform`,
      component: Admin,
      accessors: [PERMISSIONS.PERM_CUSTOMER_READ],
    },
    {
      name: "Users",
      path: `${adminBasePath}/users`,
      component: UserList,
      accessors: [PERMISSIONS.PERM_USER_READ],
    },
    {
      name: "Customers",
      path: `${adminBasePath}/customers`,
      component: CustomerList,
      accessors: [
        PERMISSIONS.PERM_CONFIG_TOOL_MANAGE,
        PERMISSIONS.PERM_CONFIG_TOOL_VIEW,
      ],
    },
    {
      name: "Customer View",
      path: `${adminBasePath}/customer/:customerInfoUuid`,
      component: CustomerView,
      excludeFromNavigation: true,
      accessors: [
        PERMISSIONS.PERM_CONFIG_TOOL_MANAGE,
        PERMISSIONS.PERM_CONFIG_TOOL_VIEW,
      ],
    },
    {
      name: "Client View",
      path: `${adminBasePath}/client/:clientInfoUuid`,
      component: ClientView,
      excludeFromNavigation: true,
      accessors: [
        PERMISSIONS.PERM_CONFIG_TOOL_MANAGE,
        PERMISSIONS.PERM_CONFIG_TOOL_VIEW,
      ],
    },
    {
      name: "Blacklisted Contacts",
      path: `${adminBasePath}/blacklisted-contacts`,
      component: BlacklistedContactsList,
      accessors: [PERMISSIONS.PERM_BLACKLIST_CONTACT_CRUD],
    },
    {
      name: "AI Call Log",
      path: `${adminBasePath}/call-log`,
      component: AiCallLogList,
      accessors: [PERMISSIONS.PERM_AW_SCHEDULE_AI_CALL],
    },
    ...(isProductionEnvironment()
      ? []
      : [
          {
            name: "Test Data",
            path: `${adminBasePath}/test-data`,
            component: TestData,
            accessors: [
              PERMISSIONS.PERM_CONFIG_TOOL_MANAGE,
              PERMISSIONS.PERM_CONFIG_TOOL_VIEW,
            ],
          },
        ]),
  ];

  const analyticsBasePath = "/analytics";
  const analyticsRoutes = [
    {
      name: "Table of Contents",
      path: `${analyticsBasePath}/table-of-contents`,
      component: TableOfContents,
    },
    {
      name: "Dashboard Details",
      path: `${analyticsBasePath}/:dashboardId/details`,
      component: DashboardDetails,
      excludeFromNavigation: true,
    },
  ];

  /**
   * CONSIDERATIONS
   * A. For sidebar
   * Please consider this structuring is dependendent upon Sidebar component
   * 1. if you want the subroutes to be shown in sidebar for a route where excludeFromNavigation is TRUE, add baseRoute to parent
   * 2. parent route having subroutes can have path AND component attributes - upon selection, parent will be active
   * 3. if parent route does not have path AND component attributes, upon selecting that link from sidebar, first child route is opened and shown as active - upon selection, parent will be highlighted
   * 4. if child route does not have accessor, parent"s accessor value will be used (NEED TO IMPLEMENT)
   * 5. if parent route does not have accossor, it"s considered accessible by all routes
   *
   * B. For route rendering
   * 1. Need to add suport for full page components
   */

  return [
    {
      name: "Dashboard",
      path: "/dashboard",
      component: Landing,
      accessors: [PERMISSIONS.PERM_SWIM_ANALYTICS_ACCESS],
    },
    {
      path: "/account/change-password",
      component: ChangePassword,
      excludeFromNavigation: true,
    },
    {
      name: "C.A.T.",
      subRoutes: catRoutes,
      basePath: catBasePath,
      accessors: [
        PERMISSIONS.PERM_CODEX_ENTITIES_CRUD,
        PERMISSIONS.PERM_CODEX_SEARCH,
      ],
    },
    {
      name: "P.A.W",
      subRoutes: paw2_0Routes,
      basePath: paw2_0BasePath,
      accessors: [
        PERMISSIONS.PERM_PAW_GROUP_USER_MANAGE,
        PERMISSIONS.PERM_PAW_GROUP_ADMIN_MANAGE,
        PERMISSIONS.PERM_PAW_LOAD_MANAGE,
      ],
    },
    {
      name: "Responses",
      subRoutes: rawRoutes,
      basePath: rawBasePath,
      accessors: [PERMISSIONS.PERM_RAW_FAX_MANAGE],
    },
    {
      name: "Switches",
      subRoutes: switchRoutes,
      basePath: switchBasePath,
      accessors: [
        PERMISSIONS.PERM_SWIM_WORKFLOW_ACCESS,
        PERMISSIONS.PERM_FAX_MANAGE,
        PERMISSIONS.PERM_RAW_FAX_MANAGE,
        PERMISSIONS.PERM_HSC_SWITCH_LIST_MANAGE,
      ],
    },
    {
      name: "Profiles",
      subRoutes: profileRoutes,
      basePath: profileBasePath,
      accessors: [
        PERMISSIONS.PERM_MEMBER_MANAGE,
        PERMISSIONS.PERM_PRESCRIBER_PROFILE_MANAGE,
      ],
    },
    {
      name: "Agent Workspace",
      subRoutes: agentWorkspaceRoutes,
      basePath: agentWorkspaceBasePath,
      accessors: [PERMISSIONS.PERM_AW_MANAGE],
    },
    {
      name: "Scheduler",
      subRoutes: schedulerRoutes,
      basePath: schedulerBasePath,
      accessors: [
        PERMISSIONS.PERM_SCHEDULER_ACCESS,
        PERMISSIONS.PERM_BULK_ACTION_CRUD,
      ],
    },
    {
      name: "Analytics",
      subRoutes: analyticsRoutes,
      basePath: analyticsBasePath,
      accessors: [
        PERMISSIONS.PERM_ANALYTICS_READ,
        PERMISSIONS.PERM_ANALYTICS_MANAGE,
      ],
    },
    {
      name: "Admin",
      subRoutes: adminRoutes,
      basePath: adminBasePath,
      accessors: [
        PERMISSIONS.PERM_USER_REGISTRATION_MANAGE,
        PERMISSIONS.PERM_BLACKLIST_CONTACT_CRUD,
        PERMISSIONS.PERM_CONFIG_TOOL_MANAGE,
        PERMISSIONS.PERM_CONFIG_TOOL_VIEW,
      ],
    },
    // redirect needs to be at the last (heavy logic)
    {
      excludeFromNavigation: true,
      redirect: true,
      path: "/",
      to: ROUTES.provideRedirectRoute(), // this path needs to point to a valid path within dashboardRoutes array
    },
  ];
};

// iterate over routes and subRoutes and exclude all inaccessible routes
// based on logged in user"s roles and accessors for each route
// What currently happens: if parent route accessor does not exists in user roles, without checking any child routes, this returns
// What should happen: child route accessor should superceed the parent route accessor
export const getRoutes = () => {
  const routes = [];

  getDashboardRoutes().forEach((r) => {
    if (!hasRoleIn(r.accessors)) return;
    const route = Object.assign({}, r);
    if (r.subRoutes) {
      const subRoutes = [];
      r.subRoutes.forEach((sr) => {
        if (!hasRoleIn(sr.accessors)) return;

        const subRoute = Object.assign({}, sr);
        subRoutes.push(subRoute);
      });
      route.subRoutes = subRoutes;
    }

    routes.push(route);
  });
  return routes;
};

export const flattenedRoutes = () => {
  const routes = [];
  getRoutes().forEach((route) => {
    if (route.path) routes.push({ ...route });
    if (route.subRoutes)
      route.subRoutes.forEach((subRoute) => routes.push({ ...subRoute }));
  });
  return routes;
};
